<template>
  <div>
    <error-message :handledError="handledError"></error-message>
    <div class="prosContainer" v-if="!handledError">
      <kiu-carousel
        v-if="
          this.configurations.carousel.display &&
          !isLastSegment &&
          displayCarousel &&
          availability.carousel
        "
        :weeks="availability.carousel[actualTripSegment]"
        @onDateChanged="(date, throwEvent) => onDateChanged(date, throwEvent)"
        :carouselConfigs="configurations.carousel"
        :isOneWay="isOneWay"
        :actualTripSegment="actualTripSegment"
        :isFirstSegment="isFirstSegment"
        :initialDates="{
          arrival: searchInformation.return_date,
          departure: searchInformation.departure_date,
        }"
      ></kiu-carousel>
      <SelectionSummary
        v-if="!isFirstSegment"
        :journeys="selectedJourneysToShow"
        @onChangeTrip="changeTrip"
        :key="actualTripSegment"
        :is-last-segment="isLastSegment"
        :airports-information="availability.airports_information"
      ></SelectionSummary>
      <PriceDetail
        v-if="isLastSegment"
        :class="!showTermsAndConditions ? 'selectionSummary__priceDetail' : 'selectionSummary__priceDetailExt'"
        :journeys="selectedJourneysToShow"
      />
      <section class="prosContainer__flightList" v-if="!isLastSegment">
        <header class="prosContainer__flightListHeader">
          <h2>{{ prosContainerTitle }}</h2>
          <div class="prosContainer__filter" v-if="orderFlightOptions">
            <span class="prosContainer__filterTitle">{{ $t('order_by') }}</span>
            <Kiu-Select
              :options="orderFlightOptions"
              v-model="flightOrderSelected"
            ></Kiu-Select>
          </div>
        </header>
        <div class="prosContainer__flightListCards">
          <itinerary-card
            v-for="(journey, jKey) in journeysToEach"
            :key="`itin_${jKey}_${journey.trip_segment}`"
            :ref="`itineraryCard_${journey.flight_id}`"
            :classes="{
              '--selected': isJourneyTouched(journey),
            }"
            :journey="journey"
            :airports-information="availability.airports_information"
            :upsellingOpened="isJourneyTouched(journey)"
            @click="onJourneyTouched(isJourneyTouched(journey), journey)"
            @onCloseUpselling="closeUpselling(journey)"
            @onFareSelected="
              (fareSelected) => onJourneySelected(journey, fareSelected)
            "
            :isCheaper="isCheaper(journey)"
          >
          </itinerary-card>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ItineraryCard from '../components/Itinerary/ItineraryCard'
import ErrorMessage from './ErrorMessage'
import mixinMethods from '../helpers/mixinMethods.js'
import { cloneDeep, get } from 'lodash'
import SelectionSummary from './selectionSummary.vue'
import moment from 'moment'
import KiuSelect from '../components/kiuSelect/kiuSelectComponent.vue'
import kiuCarousel from '../components/carousel/kiu-carousel.vue'
import { useResize } from '../helpers/useResize.js'
import PriceDetail from './PriceDetail.vue'
const MAX_TRIP = 2
export default {
  name: 'Pros',
  mixins: [mixinMethods],
  props: {
    availability: {
      required: true,
    },
    searchInformation: {
      required: false,
    },
    doubleFlightSelection: {
      type: Boolean,
      default: false,
    },
    handledError: {
      required: false,
    },
    configurations: {
      type: Object,
      default: () => {
        return {
          displayFullPrices: true,
          showFlightRemarks: false,
        }
      },
    },
    orderFlightOptions: {},
    showTermsAndConditions: {
      type: Boolean,
      default: false,
    }
  },
  provide: function () {
    return {
      configurations: this.configurations,
    }
  },
  components: {
    ItineraryCard,
    ErrorMessage,
    SelectionSummary,
    KiuSelect,
    kiuCarousel,
    PriceDetail,
  },
  data() {
    return {
      error: undefined,
      selectedJourneys: {},
      journeysTouched: {},
      isReturnView: false,
      actualTripSegment: 1,
      showBestPrices: false,
      flightOrderSelected: null,
      mappedFlights: null,
      breakpoints: null,
      bestPrices: {},
    }
  },
  created: function () {
    this.mappedFlights = cloneDeep(this.availability?.flights)
    this.breakpoints = useResize()
  },  
  watch: {
    actualTripSegment: function (actualTripSegment) {
      if (actualTripSegment === 1) {
        this.mappedFlights = cloneDeep(this.availability?.flights)
      }
      this.isReturnView = actualTripSegment !== 1
      this.$emit('isReturnView', this.isReturnView)
    },
    journeysToEach: function (journeys) {
      if (!journeys || !this.bestPrices) return
      const thereIsMoreThanOneFlight = journeys.length > 1
      const allFlightHaveSamePrice = journeys.every(
        (journey) =>
          journey.minimum_price.total === this.bestPrices[journey.trip_segment]
      )
      this.showBestPrices = thereIsMoreThanOneFlight && !allFlightHaveSamePrice
    },
    availability: {
      deep: true,
      handler: function (newAvailavility) {
        this.mappedFlights = cloneDeep(newAvailavility?.flights)
      }
    }
  },
  methods: {
    onJourneySelected: function (journeySelected, fareSelected) {
      this.parseAirportInformationMixinMethod(
        journeySelected,
        this.availability.airports_information
      )
      const tripSegment = journeySelected.trip_segment
      const journeyWithFare = cloneDeep(journeySelected)
      journeyWithFare.fare = cloneDeep(fareSelected)
      // la funcion $set es utilizada para que al asignar el valor al objeto, este sea reactivo
      this.$set(this.selectedJourneys, tripSegment, journeyWithFare)
      this.$emit('onFlightsSelected', this.selectedJourneys)
      this.$emit('onFlightdAdded', this.selectedJourneys)
    },
    onJourneyTouched: function (isJourneyTouched, journeyTouched) {
      if (!this.breakpoints.isDesktop && isJourneyTouched) {
        this.closeUpselling(journeyTouched)
        return
      }
      // this.parseUpselling(journeyTouched)
      const tripSegment = journeyTouched.trip_segment
      this.$set(this.journeysTouched, tripSegment, journeyTouched)
      // this.scrolToCard(journeyTouched.flight_id)
    },
    parseUpselling: function (journey) {
      if (!journey.upsellingParsed) {
        journey.upselling = this.mapUpsellingMixinMethod(
          this.getCurrentFareKeys(journey),
          journey.trip_segment
        )
        journey.upsellingParsed = true
      }
    },
    scrolToCard: function (flightId) {
      const journeyRef = `itineraryCard_${flightId}`
      const offset = -60
      const timeout = 50
      this.scrollToRefMixinMethod(journeyRef, offset, timeout)
    },
    closeUpselling: function (journeyTouched) {
      const tripSegment = journeyTouched.trip_segment
      this.deleteSegmentOfJourney(tripSegment)
      this.$emit('onFlightsSelected', this.selectedJourneys)
    },
    executeContinueCallback: function () {
      if (this.actualTripSegment > this.maxTrip) {
        this.$emit('onFinishSelection')
        return
      }
      window.scrollTo({ top: 0 })
      if (
        this.allFlightAreSelected &&
        this.actualTripSegment !== this.lastStepTrip
      ) {
        this.actualTripSegment = this.lastStepTrip
        return
      }
      this.actualTripSegment++
      if (this.actualTripSegment <= this.maxTrip) {
        this.nextLegFlights = this.getNextLegFlights
      }
    },
    executeBackCallback: function () {
      const flightId = get(
        this.journeysTouched,
        `[${this.actualTripSegment}].flight_id`,
        null
      )
      const itineraryRefKey = `itineraryCard_${flightId}`
      const itineraryRef = get(this.$refs, `${itineraryRefKey}[0]`, null)
      const upsellingRef = itineraryRef?.$refs['upselling']
      if (upsellingRef?.compareConditions) {
        upsellingRef.compareConditions = false
      } else if (this.isReturnView) {
        const tripSegment = Math.min(this.actualTripSegment - 1, MAX_TRIP)
        this.changeTrip(tripSegment)
        // this.deleteSegmentOfJourney(tripSegment)
        // this.actualTripSegment--
        // this.$emit('onFlightsSelected', this.selectedJourneys)
      }
    },
    changeTrip: function (tripSegment) {
      for (let index = tripSegment; index <= this.maxTrip; index++) {
        this.deleteSegmentOfJourney(index)
      }
      this.actualTripSegment = tripSegment
      this.$emit('onFlightsSelected', this.selectedJourneys)
      this.$emit('onSegmentDeleted', tripSegment)
    },
    getCurrentFareKeys: function (journey) {
      // Aca busca las "next_keys" del segmento anterior
      // Con el numero de vuelo las encuentra para ese vuelo
      // Y la info real de el upselling se encuentra en las "next_fare_keys" de ese objeto
      const currentFlightFares = get(this.previousJourneySelected, [
        'fare',
        'next_flight_fares',
        journey.flight_id,
      ])
      return currentFlightFares
        ? currentFlightFares.next_fare_keys
        : journey.upselling
    },
    isJourneyTouched: function (journey) {
      return journey === this.journeysTouched[journey.trip_segment]
    },
    deleteSegmentOfJourney: function (tripSegment) {
      this.$delete(this.journeysTouched, tripSegment)
      this.$delete(this.selectedJourneys, tripSegment)
    },
    isCheaper: function (journey) {
      if (!this.bestPrices) return false
      return (
        this.bestPrices[journey.trip_segment] === journey.minimum_price.total &&
        this.showBestPrices
      )
    },
    onDateChanged: function (payload, throwEvent) {
      if (throwEvent) {
        const firstSegment = 1
        this.changeTrip(firstSegment)
      }
      this.$emit('onDateChanged', payload)
    },
    getOrderArrowFunction: function (orderMethod = 'earliest_flights') {
      const orderMethods = {
        earliest_flights: (flightA, flightB) => {
          const datetimeA = moment(
            flightA.departure.date + 'T' + flightA.departure.time
          )
          const datetimeB = moment(
            flightB.departure.date + 'T' + flightB.departure.time
          )
          return datetimeA - datetimeB
        },
        latest_flights: (flightA, flightB) => {
          const datetimeA = moment(
            flightA.departure.date + 'T' + flightA.departure.time
          )
          const datetimeB = moment(
            flightB.departure.date + 'T' + flightB.departure.time
          )
          return datetimeB - datetimeA
        },
        lower_prices: (flightA, flightB) => {
          if (flightA.minimum_price.total == flightB.minimum_price.total) {
            const datetimeA = moment(
              flightA.departure.date + 'T' + flightA.departure.time
            )
            const datetimeB = moment(
              flightB.departure.date + 'T' + flightB.departure.time
            )
            return datetimeA - datetimeB
          } else {
            return flightA.minimum_price.total - flightB.minimum_price.total
          }
        },
        higher_prices: (flightA, flightB) =>
          flightB.minimum_price.total - flightA.minimum_price.total,
        less_stops: (flightA, flightB) =>
          flightA.connections - flightB.connections,
        higher_stops: (flightA, flightB) =>
          flightB.connections - flightA.connections,
      }
      return orderMethods[orderMethod]
    },
    getJourneyMinimumPrice: function (upselling, tripSegment) {
      return upselling.reduce((min, current) => {
        const currentTotal =
          current.fare_information.trip_segment_prices[tripSegment].total
        return currentTotal < min ? currentTotal : min
      }, Infinity)
    },
  },
  computed: {
    isOneWay: function () {
      return !this.searchInformation.return_flight
    },
    prosContainerTitle: function () {
      if (this.actualTripSegment === 1) {
        return this.$t('shopping_lib.select_outbound_flight')
      }
      return !this.isOneWay ? this.$t('shopping_lib.select_return_flight') : ''
    },
    maxTrip: function () {
      return this.isOneWay ? 1 : MAX_TRIP
    },
    lastStepTrip: function () {
      return this.maxTrip + 1
    },
    returnViewActive: function () {
      return this.doubleFlightSelection && this.isReturnView
    },
    isFirstSegment: function () {
      return this.actualTripSegment === 1
    },
    isLastSegment: function () {
      return this.actualTripSegment === this.lastStepTrip
    },
    previousTripSegment: function () {
      return this.actualTripSegment - 1
    },
    previousJourneySelected: function () {
      return this.selectedJourneys[this.previousTripSegment]
    },
    tripSegmentToEach: function () {
      return Math.max(this.actualTripSegment - 1, 1)
    },
    getFirstFlights: function () {
      if (!this.mappedFlights) return
      const firstFlights = this.availability?.first_flights.map((flightKey) => {
        const journey = this.mappedFlights[flightKey]
        if (!journey.upsellingParsed) {
          journey.upselling = this.mapUpsellingMixinMethod(
            this.getCurrentFareKeys(journey),
            journey.trip_segment
          )
          journey.minimum_price.total = this.getJourneyMinimumPrice(
            journey.upselling,
            journey.trip_segment
          )
          journey.upsellingParsed = true
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.bestPrices[journey.trip_segment] = Math.min(
          this.bestPrices[journey.trip_segment] || Infinity,
          journey.minimum_price.total
        )
        return journey
      })
      return firstFlights
    },
    getNextLegFlights: function () {
      const tripSegment = this.tripSegmentToEach
      const nextLegFlights = this.selectedJourneys[tripSegment]?.next || []
      return nextLegFlights.map((flightKey) => {
        const journey = this.mappedFlights[flightKey]
        if (!journey.upsellingParsed) {
          journey.upselling = this.mapUpsellingMixinMethod(
            this.getCurrentFareKeys(journey),
            journey.trip_segment
          )
          journey.minimum_price.total = this.getJourneyMinimumPrice(
            journey.upselling,
            journey.trip_segment
          )
          journey.upsellingParsed = true
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.bestPrices[journey.trip_segment] = Math.min(
          this.bestPrices[journey.trip_segment] || Infinity,
          journey.minimum_price.total
        )
        return journey
      })
    },
    journeysToEach: function () {
      if (this.orderFlightOptions && !this.flightOrderSelected) return []
      const journeys = this.isReturnView
        ? this.getNextLegFlights
        : this.getFirstFlights
      const journeysWithUpselling = journeys.filter(flight => Object.values(flight.upselling).length)
      return journeysWithUpselling?.sort(
        this.getOrderArrowFunction(this.flightOrderSelected?.value)
      )
    },
    allFlightAreSelected: function () {
      return Array.from({ length: this.maxTrip }, (_, i) => i + 1).every(
        (tripSegment) => !!this.selectedJourneys[tripSegment]
      )
    },
    selectedJourneysToShow: function () {
      const selectedJourneysEntries = Object.entries(this.selectedJourneys)
      const filteredEntries = selectedJourneysEntries.filter(
        ([key]) => +key < this.actualTripSegment
      )
      return Object.fromEntries(filteredEntries)
    },
    displayCarousel: function () {
      if (this.isOneWay) return true
      const carouselConfigs = this.configurations.carousel
      const displayOnDeparture =
        this.isFirstSegment && carouselConfigs.displayOnDeparture
      const displayOnArrival =
        !this.isFirstSegment && carouselConfigs.displayOnArrival
      return !this.isOneWay && (displayOnDeparture || displayOnArrival)
    },
    prepareToBackPage: function () {
      const flightId = get(
        this.journeysTouched,
        `[${this.actualTripSegment}].flight_id`,
        null
      )
      const itineraryRefKey = `itineraryCard_${flightId}`
      const itineraryRef = get(this.$refs, `${itineraryRefKey}[0]`, null)
      const upsellingRef = itineraryRef?.$refs['upselling']
      return this.isFirstSegment && !upsellingRef?.compareConditions
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
// global atpco styles
.prosContainer
  h2, h3
    display: flex
    font-weight: 400
    align-items: center
    gap: .5rem
    margin: 0
  h2, h3
    font-size: var(--font-size-md)
.selectionSummary__priceDetail
  position: fixed
  bottom: 4rem
  padding: 0
  width: calc(100% - 2rem)
  left: 50%
  transform: translate(-50%, 0)
  z-index: 1
  &Ext
    position: fixed
    bottom: 8rem
    padding: 0
    width: calc(100% - 2rem)
    left: 50%
    transform: translate(-50%, 0)
    z-index: 1
// pros container styles
.prosContainer
  display: flex
  flex-direction: column
  gap: 2rem
.prosContainer__flightList
  display: flex
  flex-direction: column
  font-family: var(--font-family)
  background: var(--color-background)
  &Header
    display: flex
    justify-content: space-between
    margin-bottom: 2rem
    flex-direction: column
    gap: .75rem
  &Cards
    display: flex
    flex-direction: column
    gap: 2rem
.prosContainer__filterTitle
  display: none

@media (min-width: 1024px)
  .prosContainer__flightListHeader
    flex-direction: row
    align-items: center
  .prosContainer__filterTitle
    display: inline
  .prosContainer
    h2
      font-size: var(--font-size-xl)
@media (min-width: 768px)      
  .selectionSummary__priceDetail
    display: none
    &Ext
      display: none         
</style>
